module.exports = __webpack_public_path__ + "static/media/Loyalty_Star_Icon.c81660a6.png";